import React, { useState } from "react";
import Title from "../../../components/Title/Title";

import prerna from "../../../assets/images/others/prerna.png";
import priya from "../../../assets/images/others/priya.png";
import yash from "../../../assets/images/others/yash.png";
import mitr from "../../../assets/images/others/mitr.png";
import mitr2 from "../../../assets/images/others/mitr2.png";
import yogita from "../../../assets/images/others/yogita.png";
import "./Aboutus.scss";

function Aboutus(props) {
  return (
    <>
      {/* <img
        // src={require("../../assets/images/bg/about2.png")}
        src={require("../../assets/images/bg/about2.png")}
        alt="About"
        className="about-img"
      /> */}
      <div className="about-us"></div>
      <div className="container-fluid2 bg2 ">
        <Title
          options={{ title: "About EFH | Online Computer Science Tuition for ICSE & CBSE", description: "Learn about EFH (Education From Home) and our mission to make online Computer Science tuition for ICSE and CBSE students of Class 9-12 simple and effective.", image: "", url: "" }}
        />

        <div className="container sectionheader ">
          <div className="row ">
            <div className="col-md-12">
              <div className="card p-3">
                <div className="text-center">
                  <h2 className="head1">
                    Building Strong Digital Minds for Tomorrow
                  </h2>
                </div>

                <p className="p1">
                  <strong>Education From Home (EFH)</strong> is built on a clear
                  belief: strong digital fundamentals are the foundation of true
                  technological mastery.
                </p>

                <p className="p1">
                  In a world driven by technology, Computer Science education
                  often focuses on tools rather than understanding. EFH was
                  created to bring clarity, depth, and purpose back into digital
                  learning. EFH exists to develop Digital education.
                </p>

                <h2 className="head2">Our Mission</h2>
                <p className="p1" style={{marginTop:'-7px'}}>
                  Building strong Computer Science foundations for young
                  learners
                   through structured, self-paced learning.
                </p>

                <h2 className="head2">Our Vision</h2>
                <p className="p1" style={{marginTop:'-7px'}}>
                  We envision a generation of students who grow into creators of
                  technology, equipped with strong computational understanding,
                  driving innovation and strengthening India’s rise as a global
                  digital leader.
                </p>

                <h2 className="head2">
                  A Thoughtfully Designed Learning Experience
                </h2>
                <p className="p1" style={{marginTop:'-4px'}}>
                  EFH is built to make Computer Science clear, engaging, and
                  effective. Lessons are delivered through Lightboard-powered
                  recorded classes, allowing students to learn at their own pace
                  while experiencing the feel of a real classroom and gaining
                  clarity on complex concepts.
                </p>
                <p className="p1">
                  Learning doesn’t stop at watching videos. Gamified quizzes,
                  progress tracking, and regular doubt-clearing support help
                  students stay motivated, avoid learning gaps, and build
                  confidence step by step.
                </p>
                <p className="p1">
                  All core lessons are taught by{" "}
                  <strong>Ms. Yogita Kumar</strong>, the academic face of EFH —
                  a Computer Science educator with 20+ years of teaching
                  experience, who has guided 2,000+ students through structured,
                  concept-first learning.
                </p>

                <h2 className="head2">What Makes EFH Different</h2>
                <p className="p1">
                  <ul className="list" style={{marginTop: '7px'}}>
                    <li className="p1">
                      Curriculum-first learning aligned with ICSE/ISC/CBSE
                      syllabi.
                    </li>
                    <li className="p1">
                      Conceptual learning over memorization.
                    </li>
                    <li className="p1">
                      Structured learning paths that build confidence.
                    </li>
                    <li className="p1">
                      Purpose-built for Indian school systems.
                    </li>
                  </ul>
                </p>

                <p className="p1">
                  EFH is not about shortcuts or certifications. It’s about
                  building a foundation so strong that advanced learning becomes
                  effortless.
                </p>

                {/* <div className="text-center">
                  <h2 className="head1">
                    Welcome to <span className="text-primary">EFH </span>{" "}
                  </h2>
                </div>
                <p className="p1">
                  <strong> EFH - Education for Home </strong>, a digital
                  learning platform designed for Gen Alpha and Gen Z students in
                  Grades 9–12, studying CBSE and ICSE. Born from a passion for
                  teaching computer science and its applications, EFH offers a
                  comprehensive approach that includes:
                </p>

                <p className="p1">
                  <ul className="list">
                    <li>Clear and simplified theoretical concepts</li>
                    <li>
                      Practical learning through hands-on projects( Projects
                      will be launched in July and will at additional price)
                    </li>
                    <li>
                      Personalized attention with extensive Q&A sessions and
                      assignments
                    </li>
                    <li>
                      Future Talks with experts, existing students, university
                      students and much more
                    </li>
                  </ul>
                </p>

                <p className="p1">
                  We focus on igniting students' passion for Computer Science,
                  reinforcing their fundamentals, and providing clear, concise
                  explanations of core concepts. Through engaging projects and
                  programs, we inspire and empower them to confidently navigate
                  the digital world, nurturing their minds to develop the very
                  essence of digital innovation.
                </p>
                <p className="p1">
                  Through the EFH app, students can access pre-recorded offline
                  classroom videos, taught by{" "}
                  <strong> Ms. Yogita Kumar,</strong>
                  an experienced educator with{" "}
                  <strong>
                    over 20 years of teaching and a legacy of mentoring more
                    than 2,000 students.
                  </strong>{" "}
                  These videos, designed for clear and effective learning, are
                  available anytime, anywhere, allowing students to learn at
                  their own pace and convenience.
                </p>

                <h2 className="head1">What makes us special </h2>

                <p className="p1">
                  <strong>EFH is different. And we’ll tell you why!</strong>
                  <ul className="list">
                    <li>
                      <strong>EXPERIENCE THAT MATTERS:</strong> Learn from a
                      seasoned educator with over 20 years of experience in
                      teaching computer science and a proven track record of
                      mentoring more than 1,500 students to success.
                    </li>
                    <li>
                      <strong>LEARN AT YOUR OWN PACE:</strong> Access our
                      offline recorded lecture videos anytime, anywhere, and
                      study at a speed that suits you best.
                    </li>
                    <li>
                      <strong>GOODBYE LANGUAGE BARRIERS:</strong> Our
                      multilingual videos are available in all major Indian
                      regional languages, enabling students to learn faster and
                      with greater clarity in the language they understand best.
                    </li>
                    <li>
                      <strong>YOUR PERSONAL LEARNING SPACE:</strong> Each
                      student receives a dedicated account to monitor overall
                      performance, grades, assignments, progress, and receive
                      tailored tips for improvement.
                    </li>
                    <li>
                      <strong>SKIN-DEEP LEARNING:</strong> Strengthen your
                      fundamentals with end-of-module quizzes after every
                      chapter, designed to ensure genuine understanding.
                      Complete thoughtfully crafted assignments to solidify your
                      knowledge and build a strong foundation.
                    </li>
                    <li>
                      <strong>YOUR 2 A.M. STUDY BUDDY:</strong> Our 24/7 chat
                      support ensures students get answers to their queries
                      within just five minutes, anytime they need help.
                    </li>
                    <li>
                      <strong>BEGINNER'S BEST FRIEND:</strong> Meet MitrZ, our
                      interactive mascot who acts as a helper, guide, and
                      support system for students and first-time users.
                    </li>
                    <li>
                      <strong>BRINGING CONCEPTS TO LIFE:</strong> Our use of a
                      Lightboard turns recorded lectures into dynamic, engaging,
                      and visually captivating classroomexperiences.
                    </li>
                    <li>
                      <strong>MONTHLY LIVE SESSIONS:</strong> Interact directly
                      with the teacher in live monthly meetings to clarify
                      doubts and deepen understanding.
                    </li>
                    <li>
                      <strong>EXTRA PRACTICE:</strong> Struggling with module
                      questions? Additional, targeted practice problems are
                      provided to help you improve.
                    </li>
                  </ul>
                </p> */}

                {/* <h2 className="head1">Founder and Your Mentor </h2> */}
                <h2 className="head1">The Heartbeat of EFH</h2>
                <p
                  className="fst-italic"
                  style={{ marginTop: "-17px", marginBottom: "10px" }}
                >
                  ~ Where experience, care, and concept-first teaching come
                  together
                </p>
                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start">
                  {/* <div className="flex-grow-1 order-2 order-md-1 px-3">
                    <p
                      className="p1"
                      style={{
                        textAlign: "justify",
                      }}
                    >
                      Yogita Kumar is a dedicated mentor with over 20 years of
                      experience in teaching computer science. Based in
                      Dehradun, India, she has helped countless students
                      transform their struggles into success, boosting both
                      their understanding and exam scores. Her passion for
                      computer science began in 1991 with Aptech and continued
                      through her MCA in 2007.
                      <br />
                      With a diverse career in corporate training, school-level
                      courses, and material development at Unisys, Yogita
                      eventually launched her own classes. The COVID-19 pandemic
                      inspired her to create EFH, blending digital learning with
                      a personal classroom touch.
                      <br />
                      Yogita’s teaching approach is student-centered, focusing
                      on individual learning styles and fostering logical,
                      analytical thinking. She makes programming (C, C++, Java,
                      Python, SQL, PLSQL) and real-world applications accessible
                      through hands-on projects, preparing students for a
                      rapidly evolving tech world.
                      <br />
                      Through it all, one thing remains constant: Yogita's
                      unwavering dedication to her students' success.
                    </p>
                  </div> */}

                  <div className="flex-grow-1 order-2 order-md-1 px-3">
                    <p
                      className="p1"
                      style={{
                        textAlign: "justify",
                      }}
                    >
                      <span className="fw-bold">Yogita Kumar</span> is the
                      mentor behind EFH and a passionate Computer Science
                      educator with 20+ years of teaching experience. Based in
                      Dehradun, India, she has helped thousands of students move
                      from confusion to confidence—improving not just exam
                      scores, but real understanding.
                      <br />
                      {/* <br /> */}
                      Her journey in Computer Science began in 1991 with Aptech
                      and grew through her MCA in 2007, followed by hands-on
                      experience across corporate training, school education,
                      and content development at Tata-Unisys. Over time, she
                      built her own classes, shaping a teaching style that
                      blends academic rigor with clarity and care. During the
                      COVID-19 pandemic, this vision evolved into EFH, combining
                      digital learning with the feel of a real classroom.
                      <br />
                      {/* <br /> */}
                      Yogita's teaching is student-first and concept-driven. She
                      focuses on helping learners think logically, break down
                      problems, and truly understand how Computer Science
                      works—rather than memorizing answers. Programming
                      languages like C, C++, Java, Python, SQL, and PLSQL are
                      taught in a way that feels practical, relevant, and
                      connected to the real world.
                      <br />
                      {/* <br /> */}
                      What sets her apart is consistency—a genuine commitment to
                      her students' growth, adapting her teaching to match how
                      today's learners think, learn, and build their future in a
                      fast-changing digital world.
                    </p>
                  </div>

                  <div className="order-1 order-md-2 mb-4 mb-md-0 text-center">
                    <img
                      src={yogita}
                      className="img-fluid rounded-circle shadow"
                      style={{
                        maxWidth: "260px",
                        height: "260px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                        border: "1px #fff solid",
                      }}
                      alt="Image"
                    />
                  </div>
                </div>

                <h2 className="head1">The Backbone of EFH</h2>

                <div className="row mt-3">
                  <div className="col-md-4">
                    <div class="card card2" style={{ width: "22rem" }}>
                      <img src={prerna} class="card-img-top" alt="img" />
                      <div class="card-body ">
                        <h5 class="card-title"> Prerna Mathur</h5>
                        <p class="card-text pb-5">
                          An HR professional and a global citizen currently
                          based in the USA, she will be working behind the
                          scenes to support students in achieving their dreams.
                          By guiding them through various projects and
                          connecting them with the right mentors, she ensures
                          their success.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div class="card card2" style={{ width: "22rem" }}>
                      <img src={priya} class="card-img-top" alt="img" />
                      <div class="card-body">
                        <h5 class="card-title"> Priya Mathur </h5>
                        <p class="card-text">
                          {" "}
                          A Delhi-based math wizard, she’s dedicated to
                          optimizing all your analytical tools. With her
                          expertise, she offers insightful feedback to help you
                          identify your strengths and weaknesses. Her guidance
                          ensures you are well-equipped to enhance your skill
                          set, preparing you to excel in both academic pursuits
                          and real-world digital challenges.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div class="card card2" style={{ width: "22rem" }}>
                      <img src={yash} class="card-img-top" alt="img" />
                      <div class="card-body">
                        <h5 class="card-title"> Yash Mathur </h5>
                        <p class="card-text pb-4">
                          A young, dynamic, and talented undergraduate student
                          at the University of Wisconsin, Madison, USA, he is
                          pivotal in bringing this vision to life. With a strong
                          passion for empowering Gen-Next and preparing them to
                          be "digitally ready," he is committed to making India
                          a digital superpower through this initiative.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <h2 className="head1" style={{marginTop:'20px'}}> 
                  {" "}
                  Meet MitrZ {" "} <img src={mitr2} alt="img" width={100} style={{marginTop:'-35px'}}/>
                  {/* Meet MitrZ <img src={mitr} alt="img" width={80} />{" "} */}
                </h2>
                
                <p
                  className="fst-italic"
                  style={{ marginTop: "-17px", marginBottom: "10px" }}
                >
                  ~ Your friendly learning buddy
                </p>
                <p className="p1">
                  Say hello to <strong>MitrZ</strong>, your go-to guide on the
                  EFH. He's here to help you explore features, understand how
                  things work, and get comfortable fast—no confusion, no stress.
                  <br />
                  <br />
                  Follow MitrZ as he pops up with tips, reminders, and helpful
                  nudges along the way. His journey with you is just getting
                  started, and together, you'll be all set to learn smarter and
                  move ahead with confidence.
                </p>

                {/* <p className="p1">
                  Meet MitrZ, your friendly and super helpful guide! He’ll walk
                  you through the website and app, ensuring you become a pro in
                  no time. Just follow his instructions, his adventures will
                  start soon and you’ll be all set to soar!
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Aboutus;
